import { apiClient } from '../../../services/api';

const networkApi = {
  // Circles
  getCircles: () => apiClient.get('/circles').then(r => r.data),
  createCircle: (data) => apiClient.post('/circles', data).then(r => r.data),
  updateCircle: (id, data) => apiClient.put(`/circles/${id}`, data).then(r => r.data),
  deleteCircle: (id) => apiClient.delete(`/circles/${id}`).then(r => r.data),

  // Circle members
  getCircleMembers: (circleId) => apiClient.get(`/circles/${circleId}/members`).then(r => r.data),
  addMemberToCircle: (circleId, data) => apiClient.post(`/circles/${circleId}/members`, data).then(r => r.data),
  removeMemberFromCircle: (circleId, customerId) =>
    apiClient.delete(`/circles/${circleId}/members/${customerId}`).then(r => r.data),

  // Connection requests
  getConnectionRequests: () => apiClient.get('/connections/requests').then(r => r.data),
  sendConnectionRequest: (data) => apiClient.post('/connections/requests', data).then(r => r.data),
  respondToRequest: (requestId, data) =>
    apiClient.put(`/connections/requests/${requestId}`, data).then(r => r.data),
  revokeConnectionRequest: (requestId) =>
    apiClient.delete(`/connections/requests/${requestId}`).then(r => r.data),

  // Pre-select a circle for the receiver, applied automatically once they accept
  setPendingCircle: (requestId, data) =>
    apiClient.put(`/connections/requests/${requestId}/pending-circle`, data).then(r => r.data),

  // User search (all public users - used for sending connection requests)
  searchUsers: (query) =>
    apiClient.get(`/users/search?q=${encodeURIComponent(query)}`).then(r => r.data),

  // Search within accepted connections only - used for adding circle members
  searchConnections: (query) =>
    apiClient.get(`/users/search?q=${encodeURIComponent(query)}&connections_only=1`).then(r => r.data),

  // Full connection details (used for the Connections list)
  getConnections: () => apiClient.get('/connections').then(r => r.data),

  // Accepted connection customer_ids (lightweight, used for "Connected" status in search)
  getAcceptedConnections: () => apiClient.get('/connections/accepted').then(r => r.data),
  disconnectConnection: (customerId) =>
    apiClient.delete(`/connections/${customerId}`).then(r => r.data),

  // Point-to-point connection status with another user
  getConnectionStatus: (customerId) =>
    apiClient.get(`/connections/status/${customerId}`).then(r => r.data),

  // Full network graph (circles + members in one call)
  getNetworkGraph: () => apiClient.get('/network/graph').then(r => r.data),
};

export default networkApi;
